import { h } from "preact";
import { useState } from "preact/hooks";
import { TOAST, ToastAction } from "services/messageBus/actions";
import { useMessageBus } from "services/messageBus";
import "./toastViewer.scss";

type ToastPayload = ToastAction["payload"];

export function ToastViewer() {
    const [payload, setPayload] = useState<ToastPayload | null>(null);
    const [style, setStyle] = useState<string>("");

    useMessageBus(TOAST, action => {
        if (payload) {
            // todo: add to queue instead
            setPayload(null);
            setStyle("");
            setTimeout(() => {
                setStyle("animate-in");
                setPayload(action.payload);
            });
            return;
        }

        setStyle("animate-in");
        setPayload(action.payload);
    });

    function dismiss() {
        setStyle("animate-out");
    }

    function onAnimationEnd(e: h.JSX.TargetedAnimationEvent<HTMLDivElement>) {
        const className = (e.target as HTMLDivElement)?.className ?? "";
        if (className.includes("animate-in")) {
            setStyle("animate-progress");
        }
        else if (className.includes("material-toastprogress")) {
            setStyle("animate-out");
        }
        else if (className.includes("animate-out")) {
            setPayload(null);
        }
    }

    if (!payload) return null;

    return (
        <div class={"material-toastmessage " + style + " " + (payload.type ?? "info")} onClick={dismiss} onAnimationEnd={onAnimationEnd}>
            <span>{payload.message}</span>
            {
                payload.undo && <span class="undo" onClick={() => {
                    setTimeout(payload.undo!);
                    dismiss();
                }}>
                    undo
                </span>
            }
            <div class="material-toastprogress" />
        </div>
    );
}
